import Vue from 'vue';
import Vuex from 'vuex';
// import vueXtestCenter from './modules/testCenter.js';
// import vueXdateCourse from './modules/dateCourse';
// import vueXcourseDetail from './modules/courseDetail';
// import vueXexam from "./modules/exam";
// 医生

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    loginName: '',
    catalogId:'',
    questionList:[],
    noteObj:{},
    noteItem:{},
    flag:true,
    activeName: 'first',
    catalogRetainId: '',
    testObj: {},
    activeIndex: 0,
		pageIndex: 1,
		pageSizeIndex: 10,
    planId: sessionStorage.getItem('planId') || '', // 保存planId
    planData: JSON.parse(sessionStorage.getItem('planData')) ||  {}, // 保存计划数据
    newRowData: JSON.parse(sessionStorage.getItem('newRowData')) || {}, // 点击保存下来考试计划数据
    candidateInfo: JSON.parse(sessionStorage.getItem('CandidateInfo')) || {}, // 点击查看保留下来当前机构的数据 - 考生申报信息
    // 教师端是否显示计划列表
    schoolExaminationShow: 1,
    getIframeScreenshot:null,//IT环境iframe截图使用
		cutNum: 1,
    isBack: false,
  },
  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin (state, user) {
      state.Authorization = user.Authorization;
      localStorage.setItem('Authorization', user.Authorization);
    },
    // 存储用户登录名
    // storageName (state, user){
    //   state.loginName = user.loginName;
    //   localStorage.setItem('loginName', user.loginName);
    // }
    changeSchoolExaminationShow(state, schoolExaminationShow){
      state.schoolExaminationShow += schoolExaminationShow;
    },
    changeNote(state, note){
      state.noteItem = note;
    },
    changePlanId(state,val) {
      state.planId = val
      sessionStorage.setItem('planId', val)
    },
    deleteplanId(state) {
      state.planId = ''
    },
    changePlanData(state,val) {
      state.planData = val
      sessionStorage.setItem('planData', JSON.stringify(val))
    },
    setRowData(state, val) {
      state.newRowData = val
      sessionStorage.setItem('newRowData', JSON.stringify(val))
    },
    setCandidateInfo(state, val) {
      state.candidateInfo = val
      sessionStorage.setItem('CandidateInfo', JSON.stringify(val))
    },
    setIframeScreenshotFun(state, val){
      state.getIframeScreenshot = val
    }
  },
  actions: {},
  modules: {
    // vueXtestCenter,
    // vueXdateCourse,
    // vueXcourseDetail,
    // vueXexam
  }
});

/**
 * 查询模块
 */
const modulesContext = require.context('@/store/modules', true, /\.js$/);

/**
 * 创建模块
 */
createStoreModules(modulesContext);

/**
 * 创建模块函数
 * @param fileArr
 */
function createStoreModules(fileArr) {
  fileArr.keys().forEach(modules => {
    store.registerModule(modules.replace(/(^\.\/)|(\.js$)/g, ''), fileArr(modules).default)
  });
}

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js